import {
  CustomGetInvoicesQuery,
  CustomGetInvoicesQueryVariables,
  GetInvoicesQuery,
  GetInvoicesQueryVariables,
  useCustomGetInvoicesQuery,
  useGetInvoicesQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export const useGetInvoices = ({ variables }: { variables: CustomGetInvoicesQueryVariables }) => {
  const {
    data: graphqlData,
    error,
    loading,
    fetchMore: more,
  } = useCustomGetInvoicesQuery({
    variables,
  });

  const getData = useCallback(({ data }: { data: CustomGetInvoicesQuery }) => {
    return data?.getInvoices?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data: CustomGetInvoicesQuery }) => {
    return data?.getInvoices?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData]);

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  return { loading, data, error, getData, getPaginatorInfo, paginatorInfo, fetchMore } as const;
};
